export default "__VITE_ASSET__CAyXKS1W__"